import { render, staticRenderFns } from "./betslip-button.vue?vue&type=template&id=ed17edb6&"
import script from "./betslip-button.vue?vue&type=script&lang=js&"
export * from "./betslip-button.vue?vue&type=script&lang=js&"
import style0 from "./betslip-button.vue?vue&type=style&index=0&id=ed17edb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports